import { LegalPageLayout, LegalSections } from "../components/LegalPageLayout";

export default function Privacy() {
  return (
    <LegalPageLayout pageKey="privacy">
      <LegalSections pageKey="privacy" />
    </LegalPageLayout>
  );
}
